<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

export default {
  name: "StoryTitle",
  extends: TextElement,
  elementPanelSettings: {
    elementGroup: "storyElements",
    elementType: "element",
    displayName: "Story Title",
    displayIcon: "text-alt",
  },
  mixins: [StoryPageElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    value() {
      return this.entity.title;
    },
    isEditable() {
      return false;
    },
  },
};
</script>
